import api from '../../plugins/api';

const getGuaranteeDocument = (appealId) => {
  return api.get('/api/bank/getGuaranteeDocument', { appealId });
};

export default getGuaranteeDocument;
